import { render, staticRenderFns } from "./PartiesView.vue?vue&type=template&id=580f5efc&scoped=true"
import script from "./PartiesView.vue?vue&type=script&lang=js"
export * from "./PartiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f5efc",
  null
  
)

export default component.exports